import { METRIC_NAME, JS_SERVER_TYPE } from '@/constants';
import { monitorSingleJsLoadTime } from '@/utils';
import { asyncLoadFile } from '@/utils/asyncLoadFile';
import { smartReport } from '@/utils/metricHelper';

let __blackbox: string = ''
export function entry(data: typeof import('@/constants')['DEFAULT_ANTI_SPIDER']['td'], extra: { server_type: keyof typeof import('@/constants')['SERVER_TYPE']['production'], env: keyof typeof import('@/constants')['DEBUG_ENV'], channel: string }) {
    if (extra?.channel == '0' || extra?.channel == '1') {
        const { url, partner, appName, normal } = data[extra.server_type]
        window._fmOpt = {
            partner,
            appName,
            interfaceProtection: true,
            normalUrl: normal,
            token: `${appName}-${Date.now()}-${Math.random().toString(16).slice(2)}`,
            collectBehavior: true,
            success: (v: string) => {
                __blackbox = v;
                window.__td_blackbox = v;
            },
            error: () => {
                __blackbox = '';
                window.__td_blackbox = '';
            }
        };
        asyncLoadFile({
            label: 'script',
            attrs: {
                // async: 'true',
                src: url,
                crossorigin: 'anonymous'
            },
        })
            .then(() => {
                smartReport({
                    metric_name: METRIC_NAME,
                    tags: { url, type: 'loadTD' },
                    value: 1,
                    message: 'td load success',
                })
            }).then(() => {
                monitorSingleJsLoadTime('fm', JS_SERVER_TYPE[extra.env][extra.server_type]);
            })
            .catch(error => {
                smartReport({
                    metric_name: METRIC_NAME,
                    tags: { url, type: 'loadTDError' },
                    value: 1,
                    message: 'td load error',
                    params: error
                })
            })
    }
}

export async function provideBlackbox(d: { validate_channel: string, brand: string }) {
    if (d.validate_channel == '0' || d.validate_channel == '1') {
        // pc pwa - __blackbox 由 TD 脚本异步回调赋值，需等待
        if (__blackbox) return __blackbox
        return new Promise<string>((resolve) => {
            const start = Date.now()
            const check = () => {
                if (__blackbox) {
                    resolve(__blackbox)
                } else if (Date.now() - start > 3000) {
                    resolve('')
                } else {
                    setTimeout(check, 100)
                }
            }
            check()
        })
    }
    if (d.brand === 'shein') {
        // shein h5
        const _b = await sheinPost()
        return _b || ''
    }
    if (d.brand === 'romwe') {
        // romwe h5
        const _b = await romwePost()
        return _b || ''
    }
    return ''
}

async function romwePost() {
    try {
        if (!window?.Wing) return ''
        window?.Wing?.post('Common/get_risk_blackbox')
        return new Promise((resolve) => {
            setTimeout(() => { // 设置超时时间
                // 超时错误 - 使用立即上报
                smartReport({
                    metric_name: METRIC_NAME,
                    tags: { type: 'loadTDError', url: 'romwe' },
                    value: 1,
                    message: 'td load error',
                    params: { timeout: 1000 }
                })
                resolve('')
            }, 1000);
            window?.Wing?.on('get_risk_blackbox', (data: any) => {
                smartReport({
                    metric_name: METRIC_NAME,
                    tags: { type: 'loadTD', url: 'romwe' },
                    value: 1,
                    message: 'td load success',
                })
                resolve(data)
            })
        })
    } catch (error) {
        smartReport({
            metric_name: METRIC_NAME,
            tags: { type: 'loadTDError', url: 'romwe' },
            value: 1,
            message: 'td load error',
            params: error
        })
        return ''
    }
}

async function sheinPost() {
    try {
        if (!window?.Wing) return ''
        const { blackBox } = await window?.Wing?.postBridge('RiskBridge/getBlackbox', {}, 1000) || {}
        smartReport({
            metric_name: METRIC_NAME,
            tags: { type: 'loadTD', url: 'shein' },
            value: 1,
            message: 'td load success',
        })
        return blackBox || ''
    } catch (error) {
        // 错误日志 - 使用立即上报
        smartReport({
            metric_name: METRIC_NAME,
            tags: { type: 'loadTDError', url: 'shein' },
            value: 1,
            message: 'td load error',
            params: error
        })
        return ''
    }
}